import {Injectable} from "@angular/core";
import {Router} from "@angular/router";

@Injectable({
    providedIn: "root"
})
export class PrintService {

    isPrinting = false;

    constructor(private router: Router) {
    }

    /**
     * Call any child print document that you have declared under common/component/print folder
     * @param documentName What type of document are you trying to print (print-child-*)
     * @param documentData String version of Object version of PARAMS or DATA
     */
    printDocument(documentName: string, documentData: string) {
        this.isPrinting = true;
        this.router.navigate(["/",
            {
                outlets: {
                    "print": ["print", documentName, documentData]
                }
            }]);
    }

    onDataReady() {
        setTimeout(() => {
            window.print();
            this.isPrinting = false;
            this.router.navigate([{outlets: {print: null}}]);
        });
    }
}
